import _slicedToArray from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var NUMBER_STYLES = new Set(['animationIterationCount', 'borderImageOutset', 'borderImageSlice', 'border-imageWidth', 'boxFlex', 'boxFlexGroup', 'boxOrdinalGroup', 'columnCount', 'fillOpacity', 'flex', 'flexGrow', 'flexNegative', 'flexOrder', 'flexPositive', 'flexShrink', 'floodOpacity', 'fontWeight', 'gridColumn', 'gridRow', 'lineClamp', 'lineHeight', 'opacity', 'order', 'orphans', 'stopOpacity', 'strokeDasharray', 'strokeDashoffset', 'strokeMiterlimit', 'strokeOpacity', 'strokeWidth', 'tabSize', 'widows', 'zIndex', 'zoom']);
var isNumeric = function isNumeric(value) {
  if (typeof value === 'number') return true;
  return !Number.isNaN(Number(value));
};
var getNumberStyleValue = function getNumberStyleValue(style, value) {
  return NUMBER_STYLES.has(style) ? value : "".concat(value, "px");
};
var uppercasePattern = /[A-Z]/g;
var kebabCase = function kebabCase(str) {
  return str.replace(uppercasePattern, '-$&').toLowerCase();
};
export function normalizeStyles(styles) {
  if (!(styles instanceof Object)) {
    return undefined;
  }
  return Object.entries(styles).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    acc[kebabCase(key)] = isNumeric(value) ? getNumberStyleValue(key, value) : value;
    return acc;
  }, {});
}